import { Fragment, useCallback, useContext, useState } from "react";
import { MediaCaptureContext } from "../../context/MediaCaptureContext";
import "./MediaComponent.css";
import { ReactComponent as Trash } from "../../../assets/media_icons/trash.svg";
import { ReactComponent as Reverse } from "../../../assets/media_icons/reverse.svg";
import MediaButton from "../MediaButton/MediaButton";
import icoCheck from '../../../assets/ico-check.svg';
import { ReactComponent as Camera } from "../../../assets/media_icons/camera.svg";

import popSound from "../../../assets/audios/pop.mp3";
import { useTimeLimitRecorder } from "./useTimeLimitRecorder";

export const TakePhotoComponent = ({
  timer = 0, // in seconds
  submitDisabled = false,
  onConfirmPhoto = () => { },
  isSendData = false
}) => {
  const { videoRef, mediaUrl, mediaBlob, takePhoto, discardPhoto, switchCamera } =
    useContext(MediaCaptureContext);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const playSound = () => {
    const sound = new Audio(popSound);
    sound.play();
  };


  const handleConfirmDecision = useCallback(() => {
    if (!mediaUrlRef.current) return;
    cleanTimeout();

    setIsSubmitting(true); // Bloqueamos los botones
    playSound();
    onConfirmPhoto(mediaUrlRef.current, mediaBlobRef.current);
  }, [onConfirmPhoto]);

  const {
    mediaBlobRef,
    mediaUrlRef,
    cleanTimeout,
  } = useTimeLimitRecorder({
    mediaBlob,
    mediaUrl,
    timer,
    onConfirmSubmit: handleConfirmDecision,
  })

  return (
    <div className="media-question-container">
      {/* Preview */}
      <div className="media-preview-wrapper">
        {mediaUrl &&
          <div className="media-preview-container">
            <img
              className="media-captured-image"
              src={mediaUrl}
              alt="video_frame"
            />
          </div>}
        <div
          className="media-preview-container"
          style={{ display: !mediaUrl ? "block" : "none" }}
        >
          <video
            ref={videoRef}
            autoPlay
            muted
            playsInline
            className="media-preview-video"
          />
          <div style={{ position: "absolute", bottom: 0, width: "100%", zIndex: 2 }}>
            <div className="flex gap-1 p-2 items-center justify-between">
              {!mediaUrl &&
                <MediaButton onClick={switchCamera}>
                  <Reverse height={35} width={35} />
                </MediaButton>}
              <MediaButton
                pressed={mediaUrl || submitDisabled}
                disabled={isSubmitting || mediaUrl || submitDisabled}
                onClick={takePhoto}
                size="lg"
                variant="red"
              >
                <Camera height={35} width={35} className="media-icon media-icon-white" />
              </MediaButton>
            </div>
          </div>
        </div>
        <div className="media-player-action-buttons">
          <Fragment>
            {mediaUrl && !submitDisabled &&
              <MediaButton
                disabled={isSubmitting}
                onClick={discardPhoto}
              >
                <Trash height={35} width={35} />
              </MediaButton>
            }
          </Fragment>
        </div>
        <div className="media-confirmation-container">
          <button className="ConfirmButton"
            onClick={handleConfirmDecision}
            disabled={isSubmitting || !mediaUrl || submitDisabled}>
            <div className="principalBtn">
              {isSubmitting ? (isSendData ? "Enviado" : "Enviando...") : "Enviar"}
              {isSendData && <img className="sendCheck" src={icoCheck} alt="player ready" />}
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default TakePhotoComponent;
